import { DriverIdDTO, DriverIdParameter, DriverIdParameterRuntype } from '@luminovo/api-contracts';

/**
 * This takes in a driverId and returns a stringified JSON object
 * which can be used as a parameter in a request.
 */
export const formatDriverIdParameter = (driverId: DriverIdDTO): DriverIdParameter => {
    return DriverIdParameterRuntype.parse(JSON.stringify(driverId));
};
